import { Component, effect, inject, signal } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { BlogPost, BlogService } from '../../../../shared/services/blog.service';
import { DatePipe } from '@angular/common';
import { PageHeader } from '../../../../shared/components/page-header/page-header';
import { NewsSidebar } from "../../../../shared/components/news-sidebar/news-sidebar";

@Component({
  selector: 'app-news-detail-page',
  imports: [DatePipe, PageHeader, NewsSidebar, RouterLink],
  templateUrl: './news-detail-page.html',
  styleUrl: './news-detail-page.scss',
})
export class NewsDetailPage {
  private route = inject(ActivatedRoute);
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private blogService = new BlogService(); // Or inject if provided in root, assuming it's a simple class as per previous files
  private router = inject(Router);
  
  post = signal<any>(null);
  isLoading = signal(true);
  urlPost = signal('');

  prevPost = signal<any>(null);
  nextPost = signal<any>(null);

  breadcrumbs = [
    { label: 'Home', route: '/' },
    { label: 'Noticias', route: '/news' },
    { label: 'Detalle Noticia', isActive: true }
  ];

  currentIndex = signal<number>(0);

  constructor() {
    effect(() => {
      this.route.params.subscribe((params) => {
        const id = params['id'];
        const index = params['index'];

        this.currentIndex.set(Number(index));

        if (id) {
          this.loadPost(id);
        }
      });
    });
  }

  async loadPost(id: string) {
    this.isLoading.set(true);
    try {
      const post = await this.blogService.getNewsDetailFromApi(id);
      const { prevPost, nextPost } = await this.blogService.getPrevAndNextPostFromApi(this.currentIndex());

      this.prevPost.set(prevPost);
      this.nextPost.set(nextPost);

      this.post.set(post);
      this.breadcrumbs[2].label = post.title;

      const url = 'https://web.dev.consultorio.biz/news/' + this.post().id;
      this.urlPost.set(url);

      // Update meta tags
      this.titleService.setTitle(post.title + ' - TuConsultorio');
      this.metaService.updateTag({ name: 'description', content: post.description || post.title });
      this.metaService.updateTag({ property: 'og:title', content: post.title });
      this.metaService.updateTag({ property: 'og:description', content: post.description || post.title });
      this.metaService.updateTag({ property: 'og:url', content: url });
      if (post.imageUrl) {
        this.metaService.updateTag({ property: 'og:image', content: post.imageUrl });
      }
    } catch (error) {
      console.error('Error loading post', error);
    } finally {
      this.isLoading.set(false);
    }
  }

  formatFileSize(bytes: number): string {
    if (!bytes) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  }

  goToNextPost() {
    this.router.navigate(['/news', this.nextPost().index, 'detail', this.nextPost().id, ]);
  }

  goToPrevPost() {
    this.router.navigate(['/news', this.prevPost().index, 'detail', this.prevPost().id, ]);
  }

  async handleSharedNews() {
    try {
      await this.blogService.shareNewsApi(this.post().id);
    } catch (error) {
      console.error('Error sharing news', error);
    }
  }
}
